/** Speakers that should always render the blue+gold empty-figure
 *  placeholder instead of whatever portrait we happen to have on file.
 *
 *  Jun-2026 (user: "put the nice placeholder of no speaker image over
 *  R' Moshe Dov Harris instead of his current picture").
 */
export const PLACEHOLDER_PORTRAIT_SPEAKERS = new Set([
  "R' Yitzchak Schwartz",
  "R' Moshe Dov Harris",
]);

export const usesPlaceholderPortrait = (name) =>
  PLACEHOLDER_PORTRAIT_SPEAKERS.has((name || '').trim());
